import { render, staticRenderFns } from "./RequestApproved.vue?vue&type=template&id=5968a140"
import script from "./RequestApproved.vue?vue&type=script&lang=js"
export * from "./RequestApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports